import React from "react";
import { Container } from "@mui/material";
import PageContent from "../../components/layout/container/PageContent";
import PersonForm from "../../components/form/PersonForm";

const ExternalMember = () => {
    return (
        <PageContent showImageHeader={false}>
            <Container maxWidth="md">
                <PersonForm paramId={null} paramTopic="EXTERNAL" />
            </Container>
        </PageContent>
    );
};

export default ExternalMember;
